export const SPECIALTY_FILE_TYPES = {
  DECLARATION_PAGES: 30,
  MVR_REPORT: 31,
  DASH_REPORT: 32,
  TYPE_ADDITIONAL_DOCUMENT: 39,
  LOA_SIGNED_DOCUMENT: 40,
  PRIOR_POLICY_DECLARATION_PAGES: 41,
  QUOTE: 42,
} as const;

export const COMMERCIAL_FILE_TYPES = {
  DECLARATION_PAGES: 30,
  QUOTE: 42,
  DASH_REPORT: 32,
  MVR_REPORT: 31,
  APPLICATION: 53,
  SUPPLEMENT: 54,
  VEHICLE_SCHEDULE: 56,
  DRIVER_SCHEDULE: 57,
  APPLICATION_SUPPLEMENT_COMBINED: 58,
} as const;
